import watchFetchDataLimitsWithUsage from './getDataLimitsWithUsage';

const watchDataLimitsUsage = [watchFetchDataLimitsWithUsage];

export default watchDataLimitsUsage;
